import {
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  USER_SUCCESS,
} from '../mutations_type.js'

import { LOGIN_API } from '../../services/api/api.js'

import axios from 'axios'
import router from '../../router/index'

const state = {
  token: localStorage.getItem('token') || '',
  user_id: localStorage.getItem('userId'),
  username: localStorage.getItem('username'),
  status: '',
  hasLoadedOnce: false,
  message: '',
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
}
const mutations = {
  [AUTH_REQUEST]: (state, payload) => {
    state.status = 'loading'
    state.message = payload
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
    state.hasLoadedOnce = true
  },
  [USER_SUCCESS]: (state, username) => {
    state.username = username
  },
  [AUTH_ERROR]: state => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: state => {
    state.token = ''
    state.username = ''
    state.user_id = ''
  },
}

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) => {
    return new Promise(reject => {
      commit(AUTH_REQUEST)
      axios({
        url: LOGIN_API,
        data: user,
        method: 'POST',
        // withCredentials: true,
      })
        .then(response => {
          // Đăng nhập thành công
          const data = response.data
          const user = data.data
          if (data.code === 0 && user) {
            const token = user.token
            localStorage.setItem('token', token)
            localStorage.setItem('username', user.username)
            localStorage.setItem('userId', user.id)
            commit('AUTH_SUCCESS', token)
            commit('USER_SUCCESS', user.username)
            if (localStorage.getItem('url')) {
              router.push(localStorage.getItem('url'))
            } else {
              router.push('/')
            }
            commit('MESSAGE_SUCCESS', 'Đăng nhập thành công', {
              root: true,
            })
            location.reload()
          }
        })
        .catch(err => {
          // Đăng nhập thất bại
          const data = err.response.data
          commit('MESSAGE_ERROR', data.message, { root: true })
          commit('AUTH_ERROR', state.message)
          localStorage.removeItem('token')
          localStorage.removeItem('username')
          localStorage.removeItem('userId')
          localStorage.removeItem('url')
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('userId')
      localStorage.removeItem('game_id')
      resolve()
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
